export const DEBUG = false
export const API_ENDPOINT = DEBUG? "http://localhost:8000": "https://epicescapetour.com"
export const ASSETS_ENDPOINT = API_ENDPOINT